import { get } from 'lodash';
import { call, put, select } from 'redux-saga/effects';
import { API } from '../../api';

const getServerConfig = ({ serverConfig }) => serverConfig;

function* fetchOptions(searchTerm) {
    const serverConfig = yield select(getServerConfig);
    try {
        const path = `/users/${serverConfig.namespace}?username=contains:${searchTerm}`;
        const result = yield call(API, 'get', 'api', path);
        return result;
    } catch (e) {
        console.error(e);
    }
    return null;
}

export function* fetchShareLayerOptions(action) {
    const searchTerm = get(action, 'payload.searchTerm');

    if (searchTerm === '' || searchTerm === null) {
        yield put({
            type: 'SET_DYNAMIC_FILTER_OPTIONS',
            payload: {
                filterResults: {
                    accounts: [],
                },
            },
        });
    } else {
        const optionsResults = yield call(
            fetchOptions,
            searchTerm,
        );

        yield put({
            type: 'SET_DYNAMIC_FILTER_OPTIONS',
            payload: {
                filterResults: {
                    accounts: optionsResults.users,
                },
            },
        });
    }
}
